export const PHONE_HREF = 'tel:6231217272';

const WHATSAPP_NUMBER = '556231217272';
const APPOINTMENT_MESSAGE = 'Olá! Vim pelo site e gostaria de agendar um exame.';

const APPOINTMENT_FIELDS = [
  ['nome', 'Nome'],
  ['cpf', 'CPF'],
  ['exame', 'Exame'],
  ['convenio', 'Convênio'],
];

export function buildAppointmentMessage(form = {}) {
  return APPOINTMENT_FIELDS.reduce((message, [field, label]) => {
    const value = String(form[field] || '').trim();
    return value ? `${message}\n*${label}:* ${value}` : message;
  }, APPOINTMENT_MESSAGE);
}

export function buildAppointmentWhatsAppUrl(form = {}) {
  const params = new URLSearchParams({
    phone: WHATSAPP_NUMBER,
    text: buildAppointmentMessage(form),
  });
  return `https://api.whatsapp.com/send/?${params.toString()}`;
}

export function isWhatsAppUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return false;

  try {
    const url = new URL(value.trim());
    if (url.protocol === 'whatsapp:') return true;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    const hostname = url.hostname.toLowerCase().replace(/^www\./, '');
    return hostname === 'wa.me' || hostname === 'whatsapp.com' || hostname.endsWith('.whatsapp.com');
  } catch {
    return false;
  }
}
